<div class="datos-geograficos-cemento-filtros">
  <div class="datos-geograficos-cemento-filtro-buscar">
    <app-cbb-field
      label="Buscar"
      placeholder="Región, provincia, comuna, códigos SAP..."
      [clearable]="true"
      [ngModel]="store.searchTerm()"
      (ngModelChange)="onSearchTermChange($event)"
    ></app-cbb-field>
  </div>
  <div class="datos-geograficos-cemento-filtro-acciones">
    <app-cbb-button
      label="Carga masiva"
      color="info"
      (action)="abrirModalCargaMasiva()"
      [disabled]="store.loading()"
    ></app-cbb-button>
    <app-cbb-button
      label="Crear registro"
      color="green"
      (action)="abrirCrear()"
      [disabled]="store.loading()"
    ></app-cbb-button>
  </div>
</div>

<div *ngIf="store.error()" class="alert alert-warning py-2" role="alert">{{ store.error() }}</div>

<app-admin-server-table
  [columns]="tableColumns"
  [rows]="store.items()"
  [loading]="store.loading()"
  [emptyMessage]="'No hay datos geográficos para mostrar.'"
  [ordering]="store.ordering()"
  [pagination]="paginationState"
  [summaryNoun]="'registros'"
  [rowTrackBy]="trackByItem"
  (orderingChange)="onOrderingChange($event)"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
></app-admin-server-table>

<ng-template #actionsCellTpl let-row>
  <div class="d-flex gap-1 justify-content-center align-items-center">
    <app-cbb-table-action-icon
      variant="edit"
      label="Editar"
      [disabled]="store.loading()"
      (action)="abrirEditar(row)"
    ></app-cbb-table-action-icon>
    <app-cbb-table-action-icon
      variant="void"
      label="Anular"
      [disabled]="store.loading()"
      (action)="prepararEliminar(row)"
    ></app-cbb-table-action-icon>
  </div>
</ng-template>

<ng-template #cargaMasivaTpl>
  <app-datos-geograficos-cemento-carga-masiva-modal
    (closeRequested)="cerrarCargaMasivaModal()"
    (uploadRequested)="subirExcelCargaMasiva($event)"
  ></app-datos-geograficos-cemento-carga-masiva-modal>
</ng-template>

<ng-template #detalleTpl>
  <app-dato-geografico-cemento-detalle-modal
    [item]="selectedItem"
    [loading]="store.loading()"
    (closeRequested)="cerrarDetalle()"
    (saveRequested)="guardar($event)"
    (deleteRequested)="solicitarEliminar()"
  ></app-dato-geografico-cemento-detalle-modal>
</ng-template>

<ng-template #confirmGuardarTpl>
  <app-politicas-entrega-confirm-delete-modal
    [loading]="store.loading()"
    [title]="tituloConfirmarGuardar"
    [message]="mensajeConfirmarGuardar"
    [entityLabel]="'registro'"
    [confirmButtonLabel]="etiquetaConfirmarGuardar"
    [confirmColor]="'green'"
    (closeRequested)="cancelarGuardar()"
    (confirmRequested)="confirmarGuardar()"
  ></app-politicas-entrega-confirm-delete-modal>
</ng-template>

<ng-template #confirmDeleteTpl>
  <app-politicas-entrega-confirm-delete-modal
    [loading]="store.loading()"
    [title]="'Confirmar eliminación'"
    [message]="'¿Desea eliminar este registro? Esta acción no se puede deshacer.'"
    [entityLabel]="'registro'"
    [confirmButtonLabel]="'Confirmar eliminación'"
    [confirmColor]="'danger'"
    (closeRequested)="cancelarEliminar()"
    (confirmRequested)="confirmarEliminar()"
  ></app-politicas-entrega-confirm-delete-modal>
</ng-template>
